import i18n from "@/core/plugins/vue-i18n";
import router from "@/router.js";
import store from "@/core/services/store";
import { LOGOUT } from "@/core/services/store/auth.module";
import Swal from "sweetalert2";
import { valueValidation } from "./dataFormatHelper.js";

export const handleSelectionValue = function (
    selections,
    value,
    fields = { id_key: "id", value_key: "name" },
    default_value = null,
) {
    const selected = selections.find((s) => s[fields.id_key] == value);
    return typeof selected != "undefined" &&
        typeof selected[fields.value_key] != "undefined"
        ? selected[fields.value_key]
        : default_value;
};

export const gotoRoute = async function (redirect_page) {
    await router.push(redirect_page);
};

export const handleApiError = function (error) {
    if (error.response != null && error.response.status == 403) {
        if (
            valueValidation(error.response.data.result) ||
            (!valueValidation(error.response.data.result.diff) &&
                parseInt(error.response.data.result.diff.hours) < 10)
        ) {
            Swal.fire({
                title: i18n.t("COMMON.MSG.TIMEOUT_ERROR"),
                text: i18n.t("COMMON.MSG.TIMEOUT_MESS"),
                icon: "warning",
                confirmButtonColor: "#6c757d",
                heightAuto: false,
            }).then(() => {
                store.dispatch(LOGOUT).then(() => router.push({ name: "login" }));
            });
        }
    } else if (error.message == "Network Error") {
        Swal.fire({
            title: i18n.t("COMMON.MSG.NETWORK_ERR"),
            text: i18n.t("COMMON.MSG.NETWORK_MESS"),
            icon: "warning",
            confirmButtonColor: "#6c757d",
            heightAuto: false,
        }).then(() => {
            store.dispatch(LOGOUT).then(() => router.push({ name: "login" }));
        });
    } else {
        throw error;
    }
};

export const handleConfirmationBox = async function (
    msg = "",
    title = i18n.t("COMMON.MSG.ARE_YOU_SURE"),
    icon = "info",
    cancel_btn = i18n.t("COMMON.BTN_NO"),
    confirm_btn = i18n.t("COMMON.BTN_YES"),
) {
    let response = await Swal.fire({
        title: title,
        html: msg,
        icon: icon,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: cancel_btn,
        confirmButtonText: confirm_btn,
    });
    return response;
};

export const handleDownloadSuccessMsg = function () {
    Swal.fire({
        icon: "success",
        text: i18n.t("COMMON.MSG.SUCCESSFULL_DOWNLOAD_FILE"),
    });
};

export const setErrorState = function (formValid, state_name, error_name, msg) {
    formValid[state_name] = false;
    formValid[error_name] = msg;
};

export const handleError = function (error, field = null) {
    if (field == null) {
        Swal.fire({
            icon: "error",
            text: error,
        });
    } else {
        field = error;
    }
};

export const mobilePage = function () {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent,
    )
        ? true
        : false;
};

export const handleSelectionSelectedValue = function (selection, field) {
    return selection[0][field];
};

export const handleFindSelected = function (selection, field, selected_value) {
    if (valueValidation(selected_value, true)) return null;
    return selection.find((s) => s[field] == selected_value);
};

export const handleFindIndex = function (selection, field, selected_value) {
    if (valueValidation(selected_value, true)) return null;
    return selection.findIndex((s) => s[field] == selected_value);
};

export const validateContactNo = function (
    calling_code,
    contact_no,
    return_msg = false,
    contact_no_label = "",
) {
    let return_err_msg = return_msg;
    let return_data = {
        status: false,
        message: "",
    };

    let full_contact = `${calling_code}${contact_no}`;
    let regex = /^\+(?:[0-9]?){6,14}[0-9]{10}$/;

    if (calling_code == "+60") {
        regex = /^(\+?6?01)[0-46-9]-*[0-9]{7,10}$|^(\+60)[1-9]{1,2}-*[0-9]{6,10}$/;
    }

    if (regex.test(full_contact)) {
        return_data.status = true;
    } else {
        return_data.message = i18n.t("COMMON.VALIDATION.INVALID", {
            name: contact_no_label,
        });

        if (calling_code == "+60") {
            return_data.message = i18n.t(
                "COMMON.VALIDATION.INVALID_CONTACT_NO_FORMAT.FORMAT_MY",
                { name: contact_no_label },
            );
        }
    }
    return return_err_msg === true ? return_data : return_data.status;
};

export const handlePlaceHolderFromTo = function (title, from = true) {
    return i18n.t(
        from ? "COMMON.PH_ENTER_DATE_FROM" : "COMMON.PH_ENTER_DATE_TO",
        { name: title },
    );
};

export const resetSummaryValue = function (rows, fields = { selected: false }) {
    for (const [key, value] of Object.entries(fields)) {
        for (let row of rows) {
            row[key] = value;
        }
    }
};

export const handleEnableButtonSpinner = function (element) {
    var buttons = document.querySelectorAll(element);
    buttons.forEach((btn) => {
        btn.classList.add("spinner", "spinner-light", "spinner-right");
        btn.disabled = true;
    });
};

export const handleDisableButtonSpinner = function (element) {
    var buttons = document.querySelectorAll(element);
    buttons.forEach((btn) => {
        btn.classList.remove("spinner", "spinner-light", "spinner-right");
        btn.disabled = false;
    });
};

export const disableForm = function (btn_element) {
    handleEnableButtonSpinner(btn_element);
    return true;
};

export const enableForm = function (btn_element) {
    handleDisableButtonSpinner(btn_element);
    return false;
};

export const vueEditorSettings = function () {
    return {
        modules: {
            toolbar: {
                container: [
                    // [{ size: ["small", false, "large"] }],
                    [
                        {
                            "inline-heading": [
                                "32px",
                                "28px",
                                "24px",
                                "18px",
                                "14px",
                                "12px",
                                "16px",
                            ],
                        },
                    ],
                    ["bold", "italic", "underline", "strike"],
                    ["blockquote", "code-block"],
                    [{ list: "ordered" }, { list: "bullet" }],
                    [{ script: "sub" }, { script: "super" }],
                    [{ indent: "-1" }, { indent: "+1" }],
                    [{ direction: "rtl" }],
                    [{ color: [] }, { background: [] }],
                    [{ font: [] }],
                    [{ align: [] }],
                    ["clean"],
                    ["link", "image", "video"],
                ],
                handlers: {
                    "inline-heading": function (value) {
                        this.quill.format("size", value);
                        const normalSize = "16px";
                        if (value === normalSize) {
                            this.quill.format("bold", false);
                        } else {
                            this.quill.format("bold", true);
                        }
                    },
                },
            },
        },
    };
};

export const renderToDefault = function (field_seq, values) {
    return field_seq.map((key) => values.find((c) => c.value === key));
};

export const selectAllText = function (ref_name) {
    const input = this.$refs[ref_name].$el.querySelector("input");
    if (input) {
        input.select();
    }
};

export const handleEmptySelectedRowMsg = function () {
    return Swal.fire({
        icon: "error",
        text: this.$t('COMMON.VALIDATION.RECORD_NO_SELECTED')
    });
}

export const handleEditorBtnVariant = function (enable_editor) {
    return enable_editor === true || enable_editor === 1 ? 'secondary' : 'primary'
}

export const handleEditorBtnTitle = function (enable_editor, title) {
    return i18n.t(enable_editor === true || enable_editor === 1 ? 'COMMON.BTN_DISABLE' : 'COMMON.BTN_ENABLED', {
        name: title
    })
}
